import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { FaStar } from 'react-icons/fa';
import api from '../../api/api';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const DeliveryFeedbackModal = ({
    isFeedbackModalOpen,
    setIsFeedbackModalOpen,
    orderId,
    delivery_boy_id,
    fetchOrderDetails
}) => {
    const { t } = useTranslation();
    const token = useSelector(state => state.user?.jwtToken);
    const [ratingReasons, setRatingReasons] = useState([]);
    const [selectedReason, setSelectedReason] = useState(null);
    const [rating, setRating] = useState(0);
    const [feedback, setFeedback] = useState('');
    const [deliveryBoyId, setDeliveryBoyId] = useState(delivery_boy_id);
    const handleClose = () => {
        setIsFeedbackModalOpen(false);
    }

    const fetchRatingReasons = async () => {
        const request = await api.getRatingReasons(token, "deliveryBoy");
        const response = await request.json();
        if (response?.data?.length > 0) {
            setRatingReasons(response?.data);
        }
    }

    useEffect(() => {
        if (isFeedbackModalOpen) {
            fetchRatingReasons();
        }
    }, [isFeedbackModalOpen]);

    const handleReasonChange = (e) => {
        setSelectedReason(e.target.value);
    }

    const handleSubmit = async () => {
        try {
            if (!token) {
                toast.error(t("login_continue"));
                return;
            }
            const request = await api.postDeliveryFeedback(token, orderId, rating, selectedReason, feedback, deliveryBoyId);
            const response = await request.json();
            if (response?.success == true) {
                toast.success(response?.message);
                fetchOrderDetails();
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            console.error("Error submitting delivery feedback", error);
            toast.error(t("something_went_wrong"));
        } finally {
            handleClose();
        }
    }

    const handleFeedbackChange = (e) => {
        setFeedback(e.target.value);
    }

    return (
        <Modal
            show={isFeedbackModalOpen}
            onHide={handleClose}
            keyboard={true}
            centered
            className='delivery-feedback-modal'
        >
            <Modal.Header className=''>
                <Modal.Title>
                    {t("delivery_feedback")}
                    <button onClick={handleClose} className='close-btn'>
                        <AiOutlineCloseCircle size={24} />
                    </button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='delivery-feedback-body'>

                <div className="rating-stars-container">
                    <h4>{t("how_was_your_experience")}</h4>
                    <p className="feedback-description">{t("rate_your_experience")}</p>
                    <div className="star-rating">
                        {[...Array(5)].map((star, index) => {
                            const ratingValue = index + 1;
                            return (
                                <label key={index}>
                                    <input
                                        type="radio"
                                        name="rating"
                                        value={ratingValue}
                                        onClick={() => setRating(ratingValue)}
                                    />
                                    <FaStar
                                        className={`star ${ratingValue <= rating ? 'active' : ''}`}
                                        size={35}
                                        onClick={() => setRating(ratingValue)}
                                    />
                                </label>
                            );
                        })}
                    </div>
                </div>

                <div className='rating-reasons-container'>
                    <div className="reasons">
                        {ratingReasons?.map((reason) => (
                            <div key={reason?.id} className={`rating-reason-item ${selectedReason == reason?.id ? 'selected' : ''}`}>
                                <input
                                    type="radio"
                                    name="rating-reason"
                                    id={reason?.id}
                                    value={reason?.id}
                                    onChange={handleReasonChange}
                                    checked={selectedReason == reason?.id}
                                />
                                <label htmlFor={reason?.id}>{reason?.reason}</label>
                            </div>
                        ))}
                    </div>
                </div>

                <div className='feedback-description-container'>
                    <div className='feedback-description-header'>
                        <h4>{t("feedback")}</h4>
                        <span>{t("optional")} :</span>
                    </div>
                    <textarea
                        placeholder={t("share_delivery_experience_placeholder")}
                        className='feedback-textarea'
                        maxLength={191}
                        onChange={handleFeedbackChange}
                        value={feedback}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer className="delivery-feedback-footer">
                <button
                    onClick={handleSubmit}
                    className='checkout_btn'
                    disabled={!rating || !selectedReason}
                >
                    {t("submit")}
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeliveryFeedbackModal